import { Fragment } from 'react';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Router from './router/Router';
import './styles/layout.scss';
import './styles/media.scss';
import './styles/reset.css';
import './styles/font.scss';
import TopButton from './components/TopButton/TopButton';
import ScrollProgress from './components/Progressbar/ScrollProgress'; // ✅ 추가

function App() {
  return (
    <Fragment>
      <div className="wrap">
        {/* ✅ 모든 페이지에서 상단 고정 프로그레스바 */}
        <ScrollProgress position="top" height={5} colorStart="#2f6f5c" colorEnd="#5ca68e" />

        <Header />
        <Router />
        <Footer />
        <TopButton />
      </div>
    </Fragment>
  );
}

export default App;
